import { Pane, ConfigureButtons } from "components/materials";
import { majorScale, minorScale } from "helpers/utilities";
import { BlankSlate } from "./BlankSlate";
import { CardHeading } from "./CardHeading";
import { CardLinkButton } from "./CardLinkButton";

export const PROJECT_LOCATIONS_CONFIGURATION_SETTINGS = {
  i: "projectLocations",
  x: 0,
  y: 7,
  w: 1,
  h: 1,
  disabled: false,
};

export function ProjectLocations({
  cards,
  isConfigurable,
  isDisabled,
  name,
  projects,
  setCards,
}) {
  const showBlankSlate = projects.length === 0;

  return (
    <Pane height="100%" width="100%" padding={majorScale(2)}>
      <Pane
        display="flex"
        marginBottom={minorScale(3)}
        justifyContent="space-between"
        paddingBottom={majorScale(2)}
      >
        <CardHeading disabled={isDisabled} text="Project Locations" />
        {isConfigurable && (
          <ConfigureButtons
            isDisabled={isDisabled}
            cards={cards}
            setCards={setCards}
            name={name}
          />
        )}
        {!isConfigurable && <CardLinkButton href="/" />}
      </Pane>
      {showBlankSlate && <BlankSlate />}
    </Pane>
  );
}
